var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3C3.11929 3 2 4.11929 2 5.5V14.5C2 15.8807 3.11929 17 4.5 17H8V16H4.5C3.67157 16 3 15.3284 3 14.5V7.5H7.07143C7.48194 7.5 7.87452 7.33175 8.15763 7.03449L9.61907 5.5H15.5C16.3284 5.5 17 6.17157 17 7V11C17.3506 11 17.6872 11.0602 18 11.1707V7C18 5.61929 16.8807 4.5 15.5 4.5H9.66667L8.06667 3.3C7.80702 3.10527 7.49122 3 7.16667 3H4.5ZM3 5.5C3 4.67157 3.67157 4 4.5 4H7.16667C7.27485 4 7.38012 4.03509 7.46667 4.1L8.69445 5.02084L7.4335 6.34483C7.33913 6.44391 7.20827 6.5 7.07143 6.5H3V5.5ZM12 10.5C12 10.2239 12.2239 10 12.5 10H15.5C15.7761 10 16 10.2239 16 10.5V12H17C18.1046 12 19 12.8954 19 14V17C19 18.1046 18.1046 19 17 19H11C9.89543 19 9 18.1046 9 17V14C9 12.8954 9.89543 12 11 12H12V10.5ZM15 11H13V12H15V11Z",
    fill: "#262626"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJob);
export default __webpack_public_path__ + "static/media/job.147511dd08257afd51f924d29149931f.svg";
export { ForwardRef as ReactComponent };